<template>
	<!-- 通用全屏切换按钮：使用 Element UI 内置图标，无额外依赖 -->
	<div class="screenfull-container" @click="handleToggleFullscreen">
		<!-- 全屏/退出全屏图标切换：Element UI 内置图标，直接复用 -->
		<i class="el-icon-full-screen screenfull-icon" v-if="!isFullscreen"></i>
		<i class="el-icon-copy-document screenfull-icon" v-else></i>
	</div>
</template>

<script>
	// 引入全屏依赖（仅需这一个外部依赖）
	import screenfull from "screenfull";

	export default {
		name: "CommonScreenfull", // 通用组件命名，避免冲突
		data() {
			return {
				// 全屏状态标记，同步更新图标
				isFullscreen: false
			};
		},
		mounted() {
			// 初始化：绑定全屏状态变化事件
			this.initFullscreenListener();
		},
		beforeDestroy() {
			// 销毁：移除事件监听，防止内存泄漏
			this.destroyFullscreenListener();
		},
		methods: {
			/**
			 * 核心：切换全屏/退出全屏
			 */
			handleToggleFullscreen() {
				// 1. 检测浏览器是否支持全屏功能
				if (!screenfull.isEnabled) {
					this.$message?.({
						message: "当前浏览器不支持全屏功能，请更换浏览器后重试",
						type: "warning",
						duration: 3000 // 提示3秒后自动关闭
					});
					return;
				}

				try {
					// 2. 切换全屏状态（screenfull核心方法）
					screenfull.toggle();
				} catch (err) {
					// 3. 捕获异常（避免特殊场景下报错）
					console.error("全屏切换失败：", err);
					this.$message?.({
						message: "全屏切换失败，请稍后重试",
						type: "error"
					});
				}
			},

			/**
			 * 同步全屏状态（更新图标）
			 */
			syncFullscreenStatus() {
				this.isFullscreen = screenfull.isFullscreen;
			},

			/**
			 * 初始化：绑定全屏状态变化事件
			 */
			initFullscreenListener() {
				if (screenfull.isEnabled) {
					// 监听全屏状态变化，同步更新组件内部状态
					screenfull.on("change", this.syncFullscreenStatus);
				}
			},

			/**
			 * 销毁：移除全屏状态变化事件监听
			 */
			destroyFullscreenListener() {
				if (screenfull.isEnabled) {
					screenfull.off("change", this.syncFullscreenStatus);
				}
			},

			// 【扩展方法】手动开启全屏（可选，提升组件通用性）
			openFullscreen() {
				if (!screenfull.isEnabled) {
					this.$message?.({
						message: "当前浏览器不支持全屏功能",
						type: "warning"
					});
					return;
				}
				screenfull.request();
			},

			// 【扩展方法】手动退出全屏（可选，提升组件通用性）
			exitFullscreen() {
				if (!screenfull.isEnabled || !screenfull.isFullscreen) return;
				screenfull.exit();
			}
		}
	};
</script>

<style scoped>
	/* 容器样式：贴合 Element UI 交互风格，点击区域适中 */
	.screenfull-container {
		display: inline-block;
		cursor: pointer;
		padding: 6px;
		border-radius: 4px;
		transition: background-color 0.2s ease;
		user-select: none; /* 禁止文字选中，避免误触 */
	}

	/* 悬浮反馈：贴合 Element UI 组件的交互风格 */
	.screenfull-container:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}

	/* Element UI 图标样式：适配图标大小和颜色，无需额外配置 */
	.screenfull-icon {
		font-size: 18px; /* Element UI 图标默认大小，贴合项目风格 */
		color: #409eff; /* Element UI 默认文字/图标颜色，统一风格 */
		transition: color 0.2s ease;
	}

	/* 悬浮时图标变色：贴合 Element UI 主题色（蓝色） */
	.screenfull-container:hover .screenfull-icon {
		color: #198afc; /* Element UI 默认主题色，与项目组件风格统一 */
	}
</style>
